import React from "react";
import { Button, notification } from "antd";

// Kiểm tra bản mới mỗi 30 phút (PWA thường được mở rất lâu không tắt)
const UPDATE_CHECK_INTERVAL = 30 * 60 * 1000;

function promptUpdate(waitingWorker) {
    const key = "pwa-update";
    notification.info({
        key,
        message: "Đã có phiên bản mới",
        description: "Bấm cập nhật để dùng phiên bản mới nhất của 1MS.",
        duration: 0,
        placement: "bottomRight",
        actions: React.createElement(
            Button,
            {
                type: "primary",
                size: "small",
                onClick: () => {
                    notification.destroy(key);
                    waitingWorker.postMessage({ type: "SKIP_WAITING" });
                },
            },
            "Cập nhật"
        ),
    });
}

export function register() {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
        return;
    }

    window.addEventListener("load", () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

        navigator.serviceWorker
            .register(swUrl)
            .then((registration) => {
                // Bản mới đã tải xong từ lần trước nhưng chưa kích hoạt
                if (registration.waiting && navigator.serviceWorker.controller) {
                    promptUpdate(registration.waiting);
                }

                registration.addEventListener("updatefound", () => {
                    const installing = registration.installing;
                    if (!installing) return;
                    installing.addEventListener("statechange", () => {
                        // Chỉ hỏi khi đã có bản cũ đang chạy (lần cài đầu thì không cần hỏi)
                        if (installing.state === "installed" && navigator.serviceWorker.controller) {
                            promptUpdate(installing);
                        }
                    });
                });

                setInterval(() => registration.update().catch(() => {}), UPDATE_CHECK_INTERVAL);
                document.addEventListener("visibilitychange", () => {
                    if (document.visibilityState === "visible") {
                        registration.update().catch(() => {});
                    }
                });
            })
            .catch((err) => console.error("Đăng ký service worker thất bại:", err));

        // Service worker mới đã kích hoạt -> tải lại trang để chạy code mới
        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
        });
    });
}
